import React from 'react';

//Components.
import VideoCardComponent from '../card-component/video-card-component/VideoCardComponent';

//Dependencies.
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Alert, Card, CardBody, CardHeader, Container } from 'reactstrap';
import { motion } from 'framer-motion';
import { allUpcomingChallenges, allActiveChallenges } from '../../slices/challengesSlice';

//Images
import hourglass from "../../images/hourglass_image.png";

//Functions.
   //Slices.
   import { allVideos, removeVideoFromFSandRedux } from '../../slices/allVideosSlice';
   //Callback.
   import { loggedInUser } from '../../slices/allUsersSlice';

import './AllVideosComponent.styles.css';
import { store } from '../../app/store';


const AllVideosComponent = ({ challengeVideos }) => {
   const storeState = store.getState();
   const videos = useSelector(allVideos);
   const currentUser = useSelector(loggedInUser);
   const location = useLocation();
   const params = useParams();
   const upcomingChallenges = useSelector(allUpcomingChallenges);
   const activeChallenges = useSelector(allActiveChallenges);
   const dispatch = useDispatch();

   const videosContainerVariant = {
      initial: {
         opacity: 0
      },
      animate: {
         opacity: 1,
         transition: {
            staggerChildren: 0.75,
            when: "beforeChildren"
         }
      }
   }

   const videoVariant = {
      initial: {
         scale: 0,
         opacity: 0
      },
      animate: {
         scale: 1,
         opacity: 1,
         transition: {
            duration: 0.25
         }
      }
   }

   if (location.pathname.endsWith("/videos/all")) {      
      return (
         <motion.div className="videosContainer" variants={videosContainerVariant} initial="initial" animate="animate">
            {
               Object.values(videos)
                  .sort((valA, valB) => (valB.record.winPct - valA.record.winPct))
                  .map((val, ind) => {
                  return (
                     storeState.allVideosSliceReducer?.isLoading ?
                     <Card>
                        <CardHeader>
                           <div style={{width: '100%'}}>
                              <img src={hourglass} alt='img. of hourglass' className='img-fluid' style={{color: 'firebrick'}} />
                           </div>
                        </CardHeader>
                        <CardBody>
                           <h3>Loading... please wait.</h3>
                        </CardBody>
                     </Card>
                     :
                     <motion.div key={val._videoID} className='p-0 m-0' variants={videoVariant}>
                        <VideoCardComponent {...val} ind={ind} />
                     </motion.div>
                  )
               })
            }
         </motion.div>
      )
   }
   else if (currentUser._userID && location.pathname.endsWith("videos/currentUser")) {
      const scanUpcomingChallengesForVideo = Object.values(upcomingChallenges).length ? Object.values(upcomingChallenges)
         .map(val => Object.keys(val.challengeVideos))
         .reduce((accumulator, val) => { 
            accumulator = [...accumulator, ...val];
            return accumulator;
         }, []) : [];

      const scanActiveChallengesForVideo = Object.values(activeChallenges).length ? Object.values(activeChallenges)
         .map(val => Object.keys(val.challengeVideos))
         .reduce((accumulator, val) => {
            accumulator = [...accumulator, ...val];
            return accumulator;
         }, []) : [];

      return (
         <motion.div className="videosContainer" variants={videosContainerVariant} initial="initial" animate="animate">
            {
               Object.values(videos)
                  .filter(val => val._userID == currentUser._userID).map((val, ind) => {
                     const payload = { _videoID: val._videoID, source: val.source };

                     const videoInChallenge = scanUpcomingChallengesForVideo.includes(payload._videoID) || scanActiveChallengesForVideo.includes(payload._videoID); //Checks if this video is currently in a challenge.

                  return (
                     <motion.div key={val._videoID} className='p-0 m-0' variants={videoVariant}>
                        <VideoCardComponent {...val} ind={ind} />
                        <div className="d-grid gap-2">
                           <button className={ videoInChallenge ? "btn btn-warning" : "btn btn-danger" } type="button" onClick={async () => await dispatch(removeVideoFromFSandRedux({...payload}))} disabled = {videoInChallenge}>{ videoInChallenge ? "Cannot Remove Video Because It Is In A Challenge Status" : "REMOVE THIS VIDEO!!!" }</button>
                        </div>
                     </motion.div>
                  )
               })
            }
         </motion.div>
      )
   }
   else if (currentUser._userID && location.pathname.endsWith(`details/announcement/${params._challengeID}`)) {
      const currentUsersVideos = Object.values(videos)
         .filter(val => (val._userID === currentUser._userID) && (!challengeVideos[val._videoID]))

      return (
         <div className={currentUsersVideos.length < 1 ? "" : "videosContainer"} style={{border: 'none', backgroundColor: 'bisque'}}>
            {
               currentUsersVideos.length < 1 ?
               <Alert color='danger' style={{border: "3px solid black"}}>
                  <h1>NO VIDEOS LEFT TO ADD!!!</h1>
               </Alert>
               :
               currentUsersVideos
                  .map((val, ind) => <VideoCardComponent {...val} ind={ind} key={val._videoID} addToChallengeButton={true} />)
            }
         </div>
      )
   }
   else if (location.pathname.endsWith(`challenges/details/active/${params._challengeID}`)) {
      return (
         <div className='videosContainer'>
            {
               Object.values(challengeVideos).map((val, ind) => {
                  return <VideoCardComponent addToChallengeButton={false} key={ind} {...val} />
               })
            }
         </div>
      )
   }
   else {
      return (
         <Container className="videosContainer">
            {
               Object.values(videos).map((val, ind) => {
                  return <VideoCardComponent {...val} ind={ind} key={val._videoID} />
               })
            }
         </Container>
      )
   }
   
}

export default AllVideosComponent